export default __webpack_public_path__ + "static/media/minus-icon.4e7ec252.svg";